<h3>{{ day | date: "EEEE, MMMM d" }}</h3>
<app-calendar-list-country *ngFor="let country of events | keyvalue" [events]="country.value" [iso2]="country.key"></app-calendar-list-country>
